import { render, staticRenderFns } from "./FlightDirection.vue?vue&type=template&id=dc488478&"
import script from "./FlightDirection.vue?vue&type=script&lang=js&"
export * from "./FlightDirection.vue?vue&type=script&lang=js&"
import style0 from "./FlightDirection.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports